import { cn } from "@/lib/utils";
import Image from "next/image";

/**
 * Two distinct marks:
 *  - "brand"  → the corporate logo (chat-bubble w/ sunglasses), used for
 *    brand/nav/favicon-adjacent surfaces.
 *  - "avatar" → the Neo character/mascot (à la Nous Research's "nous girl"),
 *    used as the assistant's face inside the conversation.
 */
const NEO_SOURCES = {
  brand: "/images/logo_neo.png",
  avatar: "/images/neo_avatar.png",
} as const;

interface NeoLogoProps {
  className?: string;
  alt?: string;
  priority?: boolean; // For above-the-fold images
  /** Which mark to render. Defaults to the corporate brand logo. */
  variant?: keyof typeof NEO_SOURCES;
}

export function NeoLogo({
  className = "h-8 w-8 mt-2",
  alt = "Neo Logo",
  priority = false, // Default to false for performance
  variant = "brand",
}: NeoLogoProps) {
  return (
    <Image
      src={NEO_SOURCES[variant]}
      alt={alt}
      width={64}
      height={64}
      className={cn("object-contain", className)}
      priority={priority} // Only true for above-the-fold images
      loading={priority ? "eager" : "lazy"} // Eager for critical images, lazy for others
      placeholder="blur" // Shows blur placeholder while loading
      blurDataURL="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0iI2Y0ZjRmNSIvPgo8L3N2Zz4K" // Light gray placeholder
    />
  );
}
